<template>
<div class="chapter">
<div class="inner_page">
<div aria-label="35" epub:type="pagebreak" id="page35" role="doc-pagebreak">
</div>
<div class="Basic-Text-Frame" id="_idContainer014">
<p class="part-number-with-part-title" id="_idParaDest-4"><span class="bold">Part Two:</span></p>
<p class="part-title-with-part-number"><span class="bold">RUBY TUESDAY</span></p>
<p class="part-ornament"><span class="bold">Pacific Ocean</span></p>
<p class="part-ornament"><span class="bold">200 Nautical Miles ENE of the Hawaiian Islands</span></p>
<p class="part-ornament"><span class="bold">Present Day</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781504096065-4.vue?50135df7